import React, { useState, useEffect } from "react";
import * as api from "../api/api";
import Loading from "../Components/Loading";
import { Modal, Button, Form } from "react-bootstrap";
import { Snackbar, Alert } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import checkAuthorization from "../config/checkAuth";
import { result } from "lodash";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";

function AdminTenantManagement() {
  const { language } = useLanguage();
  const pageTitle = "AdminTenantManagement";
  const [isLoading, setLoading] = useState(false);
  const [tenantList, setTenantList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newTenant, setNewTenant] = useState();
  const [snackbarData, setSnackbarData] = useState({});
  const [showEditingModal, setShowEditingModal] = useState(false);
  const [editingTenant, setEditingTenant] = useState(null);
  const [showInactiveModal, setShowInactiveModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    checkAuthorization("TENANT_MANAGEMENT").then((response) => {
      if (result) {
        setLoading(true);
        api
          .getAllTenants()
          .then((response) => {
            setTenantList(
              response.data.object.sort((a, b) => a.tenantId - b.tenantId)
            );
            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        navigate("/unauthorized");
      }
    });
  }, []);

  const handleCheckboxChange = async (index) => {
    const updatedItems = [...tenantList]; // Create a copy of the items array

    // Toggle the isChecked property of the item at the specified index
    updatedItems[index] = {
      ...updatedItems[index],
      isActive: !updatedItems[index].isActive,
    };

    setTenantList(updatedItems); // Update the state with the modified items array

    try {
      // Make an API call based on checkbox state
      if (updatedItems[index].isActive) {
        //await axios.post('your/api/endpoint', { data: updatedItems[index] });
        console.log("API call sent: Checkbox checked");
        api.editTenant(updatedItems[index]);
        setSnackbarData({
          ...snackbarData,
          message: strings[pageTitle][language].activated,
          show: true,
          severity: "success",
        });
      } else {
        //await axios.delete('your/api/endpoint', { data: updatedItems[index] });
        console.log("API call sent: Checkbox unchecked");
        api.editTenant(updatedItems[index]);
        setSnackbarData({
          ...snackbarData,
          message: strings[pageTitle][language].deactivated,
          show: true,
          severity: "success",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      // Handle error (e.g., show error message to user)
    }
  };

  const createTenant = (event) => {
    setShowModal(false);
    setLoading(true);
    console.log("new tenant: ", newTenant);
    event.preventDefault();
    api
      .addNewTenant({ name: newTenant })
      .then((response) => {
        console.log(response);

        // add new tenant to tenant list
        setTenantList([...tenantList, response.data.object]);
        setSnackbarData({
          ...snackbarData,
          message: strings[pageTitle][language].created,
          show: true,
          severity: "success",
        });
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const editTenant = (event) => {
    setShowEditingModal(false);
    setLoading(true);
    console.log("new tenant: ", editingTenant);
    event.preventDefault();
    api
      .editTenant(editingTenant)
      .then((response) => {
        console.log(response);
        // edit tenant in tenant list
        const updatedTenantList = tenantList.map((tenant) => {
          if (tenant.tenantId === editingTenant.tenantId) {
            return editingTenant;
          }
          return tenant;
        });
        setTenantList(updatedTenantList);
        setLoading(false);
        setSnackbarData({
          ...snackbarData,
          message: strings[pageTitle][language].editedSuccess,
          show: true,
          severity: "success",
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return isLoading ? (
    <Loading />
  ) : (
    <div className="main-content-container">
      <div className="main-content">
        <div>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={snackbarData.show}
            autoHideDuration={3000}
            onClose={() => setSnackbarData({ ...snackbarData, show: false })}
          >
            <Alert severity={snackbarData.severity}>
              {snackbarData.message}
            </Alert>
          </Snackbar>

          <Modal
            show={showInactiveModal}
            onHide={() => setShowInactiveModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {strings[pageTitle][language].deactivationModalTitle}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {strings[pageTitle][language].deactivationModalBody}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="light"
                onClick={() => setShowInactiveModal(false)}
              >
                {strings[pageTitle][language].close}
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  setShowInactiveModal(false);
                  handleCheckboxChange(tenantList.indexOf(editingTenant));
                }}
              >
                {strings[pageTitle][language].deactivate}
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Form onSubmit={createTenant}>
              <Modal.Header closeButton>
                <Modal.Title>{strings[pageTitle][language].addNew}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>{strings[pageTitle][language].name}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter tenant name"
                    autoFocus
                    onChange={(e) => setNewTenant(e.target.value)}
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="light" onClick={() => setShowModal(false)}>
                  {strings[pageTitle][language].close}
                </Button>
                <Button variant="primary" type="submit">
                  {strings[pageTitle][language].saveChanges}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
          <Modal
            show={showEditingModal}
            onHide={() => setShowEditingModal(false)}
          >
            <Form onSubmit={editTenant}>
              <Modal.Header closeButton>
                <Modal.Title>
                  {strings[pageTitle][language].editingTitle}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>{strings[pageTitle][language].name}</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter tenant name"
                    autoFocus
                    value={editingTenant?.name}
                    onChange={(e) =>
                      setEditingTenant({
                        ...editingTenant,
                        name: e.target.value,
                      })
                    }
                  />
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="light"
                  onClick={() => setShowEditingModal(false)}
                >
                  {strings[pageTitle][language].close}
                </Button>
                <Button variant="primary" type="submit">
                  {strings[pageTitle][language].saveChanges}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
          <h6 className="main-content__title">
            {strings[pageTitle][language].pageTitle}
          </h6>
          <hr className="main-content-title__hr" />
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              flexDirection: "row",
            }}
          >
            <button
              className="btn btn-outline-primary"
              onClick={() => {
                setShowModal(true);
              }}
            >
              {strings[pageTitle][language].add}
            </button>
          </div>
          <div className="main-content__body">
            <table
              style={{
                width: "95%",
                marginTop: 20,
                marginLeft: 20,
                border: "none",
              }}
            >
              <thead>
                <tr>
                  <th>{strings[pageTitle][language].tableHeaders[0]}</th>
                  <th>{strings[pageTitle][language].tableHeaders[1]}</th>
                  <th>{strings[pageTitle][language].tableHeaders[2]}</th>
                  <th>{strings[pageTitle][language].tableHeaders[3]}</th>
                  <th>{strings[pageTitle][language].tableHeaders[4]}</th>
                </tr>
              </thead>
              <tbody>
                {tenantList.map((tenant) => (
                  <tr key={tenant.tenantId}>
                    <td>{tenant.tenantId}</td>
                    <td>{tenant.name}</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={tenant.isActive}
                        onChange={() => {
                          // show a big modal with all the details
                          if (tenant.isActive) {
                            setShowInactiveModal(true);
                            setEditingTenant(tenant);
                          } else {
                            //setShowInactiveModal(true);
                            handleCheckboxChange(tenantList.indexOf(tenant));
                          }
                        }}
                      />
                    </td>
                    <td>
                      <button
                        style={{
                          border: "none",
                          outline: "none",
                          backgroundColor: "rgba(255, 0, 0, 0)",
                          color: "#00a0e5",
                        }}
                        onClick={() => {
                          console.log(tenant);
                          setEditingTenant(tenant);
                          setShowEditingModal(true);
                        }}
                      >
                        <EditIcon></EditIcon>
                      </button>
                    </td>
                    <td>
                      <button
                        style={{
                          border: "none",
                          outline: "none",
                          backgroundColor: "rgba(255, 0, 0, 0)",
                          color: tenant.isActive ? "#00a0e5" : "red",
                          cursor: tenant.isActive ? "pointer" : "not-allowed",
                        }}
                        disabled={!tenant.isActive}
                        onClick={() => {
                          sessionStorage.setItem(
                            "userTenant",
                            JSON.stringify({
                              tenantId: tenant.tenantId,
                              name: tenant.name,
                              isActive: tenant.isActive,
                            })
                          );
                          navigate("/");
                        }}
                      >
                        {strings[pageTitle][language].switch}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminTenantManagement;
